export interface Category {
  name: string;
  displayName: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    displayName: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20elegant%20cream%20colored%20sneakers%20placed%20on%20a%20light%20beige%20textured%20surface%20with%20soft%20natural%20lighting%20highlighting%20the%20stitching%20and%20fabric%20details%20minimalist%20product%20photography%20warm%20neutral%20tones%20clean%20aesthetic&width=400&height=300&seq=cat-img-shoes&orientation=landscape",
  },
  {
    name: "Hoodies/Sweaters",
    displayName: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20soft%20beige%20hoodie%20on%20a%20warm%20cream%20linen%20background%20with%20gentle%20natural%20light%20creating%20subtle%20fabric%20shadows%20minimalist%20fashion%20flat%20lay%20editorial%20style%20warm%20earthy%20tones&width=400&height=300&seq=cat-img-hoodies&orientation=landscape",
  },
  {
    name: "T-Shirts",
    displayName: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20crisp%20white%20cotton%20tshirt%20folded%20neatly%20on%20a%20light%20oak%20surface%20with%20natural%20window%20light%20illuminating%20the%20fabric%20texture%20clean%20minimalist%20aesthetic%20warm%20cream%20background%20editorial%20fashion%20photography&width=400&height=300&seq=cat-img-tshirts&orientation=landscape",
  },
  {
    name: "Jackets",
    displayName: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-honour-line",
    image: "https://readdy.ai/api/search-image?query=A%20stylish%20camel%20colored%20lightweight%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20wall%20with%20soft%20daylight%20highlighting%20the%20fabric%20drape%20and%20texture%20refined%20minimalist%20editorial%20style&width=400&height=300&seq=cat-img-jackets&orientation=landscape",
  },
  {
    name: "Pants/Shorts",
    displayName: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20well%20tailored%20beige%20trousers%20neatly%20folded%20on%20a%20light%20linen%20surface%20with%20soft%20natural%20light%20creating%20gentle%20shadow%20patterns%20minimalist%20fashion%20editorial%20warm%20neutral%20color%20palette&width=400&height=300&seq=cat-img-pants&orientation=landscape",
  },
  {
    name: "Headwear",
    displayName: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-2-line",
    image: "https://readdy.ai/api/search-image?query=A%20classic%20cream%20colored%20baseball%20cap%20placed%20on%20a%20light%20wooden%20surface%20with%20soft%20natural%20window%20light%20minimalist%20product%20photography%20warm%20beige%20tones%20clean%20composition%20subtle%20shadow%20details&width=400&height=300&seq=cat-img-headwear&orientation=landscape",
  },
  {
    name: "Sets",
    displayName: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Two%20coordinated%20fashion%20items%20in%20matching%20warm%20sand%20tones%20a%20top%20and%20bottom%20set%20folded%20together%20on%20a%20clean%20cream%20surface%20soft%20natural%20lighting%20elegant%20minimalist%20editorial%20style%20harmonious%20composition&width=400&height=300&seq=cat-img-sets&orientation=landscape",
  },
  {
    name: "Underwear",
    displayName: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20undergarments%20in%20warm%20cream%20tones%20folded%20with%20care%20on%20a%20light%20linen%20surface%20gentle%20diffused%20natural%20lighting%20creating%20a%20calm%20and%20refined%20atmosphere%20minimalist%20product%20photography&width=400&height=300&seq=cat-img-underwear&orientation=landscape",
  },
  {
    name: "Jersey",
    displayName: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20sporty%20jersey%20top%20in%20warm%20sand%20tone%20laid%20flat%20on%20a%20light%20textured%20surface%20with%20soft%20natural%20lighting%20highlighting%20the%20fabric%20weave%20and%20subtle%20details%20clean%20minimalist%20sportswear%20editorial%20style&width=400&height=300&seq=cat-img-jersey&orientation=landscape",
  },
  {
    name: "Accessories",
    displayName: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-crown-line",
    image: "https://readdy.ai/api/search-image?query=A%20collection%20of%20minimalist%20accessories%20including%20a%20leather%20bracelet%20and%20a%20delicate%20necklace%20arranged%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20light%20creating%20elegant%20gentle%20shadows%20refined%20lifestyle%20editorial&width=400&height=300&seq=cat-img-accessories&orientation=landscape",
  },
  {
    name: "Bags",
    displayName: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image: "https://readdy.ai/api/search-image?query=An%20elegant%20tan%20leather%20handbag%20placed%20on%20a%20light%20travertine%20surface%20with%20soft%20natural%20window%20light%20illuminating%20the%20leather%20grain%20and%20gold%20hardware%20minimalist%20luxury%20editorial%20style%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-bags&orientation=landscape",
  },
  {
    name: "Belts",
    displayName: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-wifi-line",
    image: "https://readdy.ai/api/search-image?query=A%20classic%20brown%20leather%20belt%20coiled%20elegantly%20on%20a%20warm%20cream%20linen%20surface%20with%20soft%20natural%20lighting%20creating%20subtle%20shadows%20minimalist%20accessory%20photography%20editorial%20style&width=400&height=300&seq=cat-img-belts&orientation=landscape",
  },
  {
    name: "Perfumes",
    displayName: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=An%20amber%20colored%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20on%20a%20cream%20marble%20surface%20with%20soft%20diffused%20natural%20light%20creating%20a%20warm%20elegant%20atmosphere%20minimalist%20beauty%20editorial%20style%20refined%20composition&width=400&height=300&seq=cat-img-perfumes&orientation=landscape",
  },
  {
    name: "Other Stuff",
    displayName: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20miscellaneous%20lifestyle%20accessories%20including%20a%20small%20notebook%20and%20a%20pair%20of%20sunglasses%20arranged%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20light%20minimalist%20editorial%20style%20clean%20composition&width=400&height=300&seq=cat-img-other&orientation=landscape",
  },
];

export const categoryFeatures = [
  {
    name: "Sneakers Database",
    description: "La collezione più completa di sneakers con dati aggiornati, prezzi e disponibilità.",
    image: "https://readdy.ai/api/search-image?query=Three%20different%20pairs%20of%20designer%20sneakers%20in%20cream%20white%20and%20warm%20stone%20tones%20arranged%20artistically%20on%20a%20textured%20beige%20surface%20with%20soft%20natural%20window%20light%20creating%20elegant%20shadows%20editorial%20fashion%20photography%20warm%20refined%20palette&width=800&height=600&seq=sneakers-db-v2&orientation=landscape",
    category: categories[0],
  },
  {
    name: "Streetwear Hub",
    description: "Hoodies, t-shirt e felpe: tutto lo streetwear che cerchi in un unico database.",
    image: "https://readdy.ai/api/search-image?query=Stylishly%20folded%20premium%20hoodies%20in%20warm%20gray%20and%20sand%20tones%20with%20a%20cap%20and%20sneakers%20styled%20nearby%20on%20a%20light%20oak%20surface%20soft%20diffused%20daylight%20warm%20inviting%20atmosphere%20modern%20streetwear%20editorial%20aesthetic&width=800&height=600&seq=streetwear-hub-v2&orientation=landscape",
    category: categories[1],
  },
  {
    name: "Accessories Guide",
    description: "Borse, cinture, profumi e accessori: tutto ciò che completa il tuo stile.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20leather%20bags%20belts%20and%20perfume%20bottles%20in%20warm%20tan%20and%20cream%20tones%20on%20a%20light%20travertine%20surface%20with%20soft%20natural%20lighting%20luxurious%20refined%20editorial%20style%20harmonious%20warm%20palette&width=800&height=600&seq=accessories-guide-v2&orientation=landscape",
    category: categories[9],
  },
];